import {
  COACH_COMPONENT_TEMPLATES_LIBRARY_CHECKIN_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_HABIT_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_LESSON_ROUTE,
  COACH_COMPONENT_TEMPLATES_LIBRARY_WORKOUT_ROUTE,
} from "../../routes/routes";

export const componentLibraryNavigation = () => [
  {
    name: "Workouts",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_WORKOUT_ROUTE,
  },
  {
    name: "Habits",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_HABIT_ROUTE,
  },
  {
    name: "Checkins",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_CHECKIN_ROUTE,
  },
  {
    name: "Lessons",
    link: COACH_COMPONENT_TEMPLATES_LIBRARY_LESSON_ROUTE,
  },
];
